import React, {useMemo, useState} from "react";
import {
  Modal,
  Button,
  Row,
  Col,
  Card,
  Table,
  FormControl,
} from "react-bootstrap";
import RateConModal from "./RateConModal";
import PodReceipts from "./PodReceipts";
import CreatePaydayModal from "./CreatePaydayModal";


const ViewPaydayModal = ({ show, onHide, data }) => {
  // 🔹 States
  const [showRateCon, setShowRateCon] = useState(false);
  const [currentRC, setCurrentRC] = useState(null);

  const [showPod, setShowPod] = useState(false);
  const [currentPod, setCurrentPod] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  // 🔹 Sample jobs data
  const jobs = [
    {
      jobId: "jobA1",
      completedDate: "2023-10-11",
      assignedDate: "2023-10-01",
      pickup: "Location A",
      dropoff: "Location B",
      amount: 283,
    },
    {
      jobId: "jobA2",
      completedDate: "2023-10-12",
      assignedDate: "2023-10-01",
      pickup: "Location A",
      dropoff: "Location B",
      amount: 537,
    },
  ];

  // 🔹 Handlers
  const handleOpenRateCon = (jobId) => {
    setCurrentRC(jobId);
    setShowRateCon(true);
  };

  const handleOpenPod = (jobId) => {
    setCurrentPod(jobId);
    setShowPod(true);
  };

  const expenses = useMemo(() => {
    try {
      return data?.expenses ? JSON.parse(data.expenses) : [];
    } catch (e) {
      return [];
    }
  }, [data]);

  const gross_earning = data?.jobs?.reduce((sum, job) => sum + (Number(job?.job?.job_amount) || 0), 0)
  const total_expense = expenses?.reduce((sum, e) => sum + Number(e.amount), 0)

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Payday Statement Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Driver Info */}
        <div className="mb-4">
          <p>
            <strong>Driver:</strong> {data?.driver?.full_name ?? '-'}
          </p>
          <p>
            <strong>Paid Date:</strong> {data?.paid_date}
          </p>
          <p>
            <strong>Status:</strong>{" "}
            <span className={`badge ${data?.is_paid === "PAID" ? "bg-success" : "bg-danger"}`}>{data?.is_paid}</span>
          </p>
        </div>

        <Row>
          {/* Summary */}
          <Col md={6}>
            <Card className="mb-3 bg-light">
              <Card.Header>Summary</Card.Header>
              <Card.Body>
                <div className="d-flex justify-content-between">
                  <span>Gross Earnings:</span>
                  <span className="text-success fw-semibold">${parseFloat(gross_earning)?.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>Total Expenses:</span>
                  <span className="text-danger fw-semibold">${parseFloat(total_expense)?.toFixed(2)}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between">
                  <span>Net Earnings:</span>
                  <span className="text-primary fw-bold">${parseInt(gross_earning-total_expense)?.toFixed(2)}</span>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Expenses */}
          <Col md={6}>
            <Card className="mb-3 bg-light">
              <Card.Header>Expenses</Card.Header>
              <Card.Body>
                {
                  expenses?.map((val,index)=> (
                      <div key={index} className="d-flex justify-content-between">
                        <span>{val?.name} :</span>
                        <span className="fw-medium">${parseFloat(val?.amount)?.toFixed(2)}</span>
                      </div>
                  ))
                }
                {/*<div className="d-flex justify-content-between">*/}
                {/*  <span>Fuel:</span>*/}
                {/*  <span className="fw-medium">-${parseFloat(expenses?.[1]?.amount)?.toFixed(2)}</span>*/}
                {/*</div>*/}
                {/*<div className="d-flex justify-content-between">*/}
                {/*  <span>Insurance:</span>*/}
                {/*  <span className="fw-medium">-${parseFloat(expenses?.[2]?.amount)?.toFixed(2)}</span>*/}
                {/*</div>*/}
              </Card.Body>
            </Card>
          </Col>

          {/* Jobs Table */}
          <Col md={12}>
            <div
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Job ID</th>
                    <th>Completed Date</th>
                    <th>Assigned Date</th>
                    <th>Pickup</th>
                    <th>Drop-off Location</th>
                    <th>Rate Con</th>
                    <th>POD/Receipts</th>
                    <th>Job Amount</th>
                    <th>Broker Name</th>
                    <th>RC Number</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.jobs?.length > 0 && data?.jobs.map((job) => (
                    <tr key={job.id}>
                      <td>{job?.id}</td>
                      <td>{job?.job?.completed_date}</td>
                      <td>{job?.job?.completed_date}</td>
                      <td>{job?.job?.pickup_address}</td>
                      <td>{job?.job?.drop_address}</td>
                      <td>
                        {
                          job?.job?.rate_confirmation_document ?
                              <Button
                                  variant="link"
                                  size="sm"
                                  onClick={() => handleOpenRateCon(job)}
                              >
                                View
                              </Button>
                              :
                              <div className={"badge bg-danger"}>No Rate Doc</div>
                        }
                      </td>
                      <td>
                        <Button
                          variant="link"
                          size="sm"
                          onClick={() => handleOpenPod(job)}
                        >
                          View
                        </Button>
                      </td>
                      <td>${job?.job?.job_amount}</td>
                      <td>
                        {job?.broker_name}
                      </td>
                      <td>
                        {job?.rc_number}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </Modal.Body>

      {/* Modals */}
      <RateConModal
        show={showRateCon}
        onHide={() => setShowRateCon(false)}
        job={currentRC}
      />
      <PodReceipts
        show={showPod}
        onHide={() => setShowPod(false)}
        job={currentPod}
      />

      <Modal.Footer>
        {/*<Button variant="secondary" onClick={() => setShowCreateModal(true)}>
          Edit
        </Button>*/}
        {/*<Button variant="danger">Delete</Button>*/}
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
        {/* --- MODALS --- */}
        {showCreateModal && (
        <CreatePaydayModal
          show={showCreateModal}
          onHide={() => setShowCreateModal(false)}
        />
      )}
    </Modal>
  );
};

export default ViewPaydayModal;
